export default __webpack_public_path__ + "static/media/mShorts_1_c3.38b61448.jpeg";